import DashboardStats from './DashboardStats';
export default DashboardStats;
